import { Progress } from "antd"
import { useSelector } from "react-redux"

import { getAdjustedOnboardingStep } from "../../../../Utils/onboarding/getAdjustedOnboardingStep"

const GettingStartedProgressIcon = () => {
  const nextStep = useSelector((state) => state.auth?.userInfo?.next_step)
  const new_onboarding_finished = useSelector(
    (state) => state.auth.userInfo.new_onboarding_finished
  )
  const step = nextStep === 2 ? 0.1 : nextStep - 2
  const completedSteps = getAdjustedOnboardingStep(step, new_onboarding_finished)
  const totalSteps = 7
  const percent = Math.round((completedSteps / totalSteps) * 100)

  return (
    <div style={{ marginRight: 8 }}>
      <Progress type="circle" percent={percent} width={20} showInfo={false} strokeColor="#225AEA" />
    </div>
  )
}

export default GettingStartedProgressIcon
